export default __webpack_public_path__ + "static/media/hashtag-icon.7b7f0e45.svg";